import { Controller } from "../../lib/stimulus-shim"

// Copie un texte dans le presse-papier (bundle profiles, via le shim Stimulus)
export default class extends Controller {
  static values = {
    text: String,
    successMessage: { type: String, default: "Copié !" }
  }

  copy(event) {
    event.preventDefault()
    navigator.clipboard.writeText(this.textValue).then(() => {
      this._showFeedback(event.currentTarget)
    }).catch((err) => console.error("Failed to copy:", err))
  }

  _showFeedback(button) {
    const original = button.innerHTML
    button.innerHTML = `<span class="text-success">${this.successMessageValue}</span>`
    setTimeout(() => { button.innerHTML = original }, 2000)
  }
}
